import {
  RUN_FUNCTION_ERROR,
  MASS_RUN_FUNCTION_ERROR,
  RUN_FUNCTION_REQUEST,
  MASS_RUN_FUNCTION_REQUEST,
  RUN_FUNCTION_SUCCESS,
  MASS_RUN_FUNCTION_SUCCESS,
} from "../actions";

import { FunctionsActions } from "../actionCreators";

const initialState = false;

const isFunctionRunningReducer = (
  state = initialState,
  action: FunctionsActions
): boolean => {
  switch (action.type) {
    case MASS_RUN_FUNCTION_REQUEST:
    case RUN_FUNCTION_REQUEST:
      return true;

    case MASS_RUN_FUNCTION_SUCCESS:
    case MASS_RUN_FUNCTION_ERROR:
    case RUN_FUNCTION_SUCCESS:
    case RUN_FUNCTION_ERROR:
      return false;

    default:
      return state;
  }
};

export default isFunctionRunningReducer;
